/** Session + event bridge so unread state survives remounts and FCM/Pusher can notify the widget. */

export const SUPPORT_CHAT_UNREAD_SESSION_KEY = "support_chat_unread";
export const SUPPORT_CHAT_LAST_SEEN_ID_KEY = "support_chat_last_seen_message_id";
export const SUPPORT_CHAT_UNREAD_EVENT = "support-chat-unread-changed";

export function readSupportChatUnreadFlag() {
  try {
    return sessionStorage.getItem(SUPPORT_CHAT_UNREAD_SESSION_KEY) === "1";
  } catch (_) {
    return false;
  }
}

export function markSupportChatUnread() {
  try {
    sessionStorage.setItem(SUPPORT_CHAT_UNREAD_SESSION_KEY, "1");
  } catch (_) {}
  try {
    window.dispatchEvent(new CustomEvent(SUPPORT_CHAT_UNREAD_EVENT));
  } catch (_) {}
}

export function clearSupportChatUnread() {
  try {
    sessionStorage.removeItem(SUPPORT_CHAT_UNREAD_SESSION_KEY);
  } catch (_) {}
  try {
    window.dispatchEvent(new CustomEvent(SUPPORT_CHAT_UNREAD_EVENT));
  } catch (_) {}
}

export function readLastSeenMessageId() {
  try {
    return sessionStorage.getItem(SUPPORT_CHAT_LAST_SEEN_ID_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function updateLastSeenMessageId(id) {
  if (id == null || String(id).trim() === "") return;
  try {
    sessionStorage.setItem(SUPPORT_CHAT_LAST_SEEN_ID_KEY, String(id).trim());
  } catch (_) {}
}

export function getLatestMessageId(messages) {
  if (!Array.isArray(messages) || messages.length === 0) return "";
  let maxId = "";
  let maxNum = -1;
  for (const m of messages) {
    const id = m?.id;
    if (id == null || String(id).trim() === "") continue;
    const n = Number(id);
    if (Number.isFinite(n) && n > maxNum) {
      maxNum = n;
      maxId = String(id);
    } else if (!Number.isFinite(n) && String(id) > maxId) {
      maxId = String(id);
    }
  }
  return maxId;
}
